import React from 'react';
import { HorizontalGroup, Text } from '@libs/uikit/Components';
import { Title } from '../options/Title';
import { StyledMain } from '../StyledMain';
import { List } from './List';

const textStyle = {
    color: '#8c9094',
    fontSize: '12px',
    margin: 0,
};

export const HeaderBidding = ({ isActive, switchInputState, ...props }) => {
    const toggle = () => switchInputState(!isActive);
    return (
        <StyledMain>
            <Title>Configure Header Bidding</Title>
            <HorizontalGroup>
                <input type="checkbox" checked={isActive} onChange={toggle} />
                <Text onClick={toggle} style={textStyle}>
                    Turn on
                </Text>
            </HorizontalGroup>
            <Text style={textStyle}>
                Paste and prioritize up to 5 third party VAST/VPAID URLs to fill the adspot with pre-bid ads
            </Text>
            {isActive && <List {...props} />}
        </StyledMain>
    );
};
